var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F644(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M45.5 40c6.076 0 11-4.924 11-11 0-1.637-.367-3.186-1.008-4.582-2.82-1.281-6.264-2.043-9.992-2.043s-7.17.762-9.99 2.043A10.92 10.92 0 0 0 34.5 29c0 6.076 4.924 11 11 11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M46.002 22.388a4.5 4.5 0 1 0 8.232 2.514c0-.362-.053-.71-.135-1.048-2.396-.884-5.15-1.412-8.097-1.466z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.5 40c6.076 0 11-4.924 11-11 0-1.637-.367-3.186-1.008-4.582-2.82-1.281-6.264-2.043-9.992-2.043s-7.17.762-9.99 2.043A10.92 10.92 0 0 0 7.5 29c0 6.076 4.924 11 11 11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M19.002 22.388a4.5 4.5 0 1 0 8.232 2.514c0-.362-.054-.71-.135-1.048-2.396-.884-5.15-1.412-8.097-1.466zM40.581 47.326c-5.403-2.538-11.787-2.54-17.196-.012-1.339.645.329 4.15 1.662 3.5 3.571-1.665 8.896-2.306 13.875.01 1.334.619 3.077-2.812 1.659-3.498z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F644);
export default __webpack_public_path__ + "static/media/1f644.e2709e2b1c3c1af42da57e8d93136227.svg";
export { ForwardRef as ReactComponent };